__webpack_require__.p = "/RevathiGollapudi_Portfolio/";